var prevStartup = __webpack_require__.x;
var hasRun = false;
__webpack_require__.x = () => {
	if (!hasRun) {
	  hasRun = true;
	  __webpack_require__(/*! ./node_modules/.federation/entry.9380b1a4e0d062cfdf9044aa44902e7d.js */ "./node_modules/.federation/entry.9380b1a4e0d062cfdf9044aa44902e7d.js");
	}
	if (typeof prevStartup === 'function') {
	  return prevStartup();
	} else {
	  console.warn('[Module Federation] prevStartup is not a function, skipping startup execution');
	}
};